/** Shared sub-nav for the Adopt section (Browse / My listings / My adoptions + Post CTA). */
import { NavLink, useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/app/adopt', label: 'Browse', end: true, testid: 'adopt-tab-browse' },
  { to: '/app/adopt/mine', label: 'My listings', testid: 'adopt-tab-mine' },
  { to: '/app/adopt/adoptions', label: 'My adoptions', testid: 'adopt-tab-adoptions' },
];

export function AdoptTabs() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="adopt-tabs">
      <div className="flex flex-wrap gap-1.5" role="tablist">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={t.testid}
            className={({ isActive }) =>
              cn(
                'rounded-full border-2 px-3 py-1.5 text-sm font-semibold transition-all duration-fast',
                isActive
                  ? 'border-primary bg-primary/10 text-primary shadow-clay-sm'
                  : 'border-brand-outline-variant/20 bg-card text-muted-foreground hover:border-primary/30 hover:text-foreground',
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <Button variant="gradient" size="sm" className="ml-auto" onClick={() => navigate('/app/adopt/new')} data-testid="adopt-post-cta">
        <Plus className="h-4 w-4" /> Post a pet
      </Button>
    </div>
  );
}
